<template>
  <ValidationObserver ref="observer">
    <div>
      <component-header
        title="Edit Customer"
        :hasReload="false"
        :hasSearch="false"
        :hasback="false"
        :hasCreate="false"
      />
      <b-card>
        <b-row class="mt-3">
          <b-col md="6">
            <c-input
              inputType="text"
              lableText="First Name"
              v-model="firstName"
            />
          </b-col>
          <b-col md="6">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="Last Name"
            >
              <c-input
                inputType="text"
                lableText="Last Name"
                v-model="lastName"
              />
              <span class="validate-error custm-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-col>
          <b-col md="6">
            <div class="form-group has-float-label">
              <b-input readonly lableText="Email" v-model="email" />
              <label for="email">Email</label>
            </div>
          </b-col>
          <b-col md="6">
            <c-tel-input
              :disabled="true"
              v-model="phone"
              :defaultInput="phone"
            />
          </b-col>
          <b-col md="6">
            <div class="form-group has-float-label">
              <b-input readonly lableText="Unit Type" v-model="unitType" />
              <label for="unitType">Unit Type</label>
            </div>
          </b-col>
          <b-col md="6">
            <div class="form-group has-float-label">
              <b-input readonly lableText="Unit" v-model="unit" />
              <label for="unitType">Unit</label>
            </div>
          </b-col>
          <!-- <b-col md="6">
          <p><strong>Floor:</strong> {{ floor }}</p>
        </b-col> -->
          <!-- <b-col md="6">
          <p><strong>Block:</strong> {{ block }}</p>
        </b-col> -->
          <!-- <b-col md="6">
          <p><strong>Lease Start:</strong> {{ leaseStart }}</p>
        </b-col> -->
          <!-- <b-col md="6">
          <p><strong>Lease End:</strong> {{ leaseEnd }}</p>
        </b-col> -->
          <!-- <b-col md="6">
          <eb-select
            type="select"
            label="label"
            placeholder="Select Unit Type"
            v-model="unitType"
            :options="unitOption"
            @input="onSelectUnitType"
            class="mt-0 currencyNameDropdown mb-0"
          ></eb-select>
        </b-col> -->
          <!-- <b-col md="6">
          <eb-select
            type="select"
            label="unitNo"
            placeholder="Select Unit"
            v-model="unit"
            :options="units"
          ></eb-select>
        </b-col> -->
          <b-col md="6">
            <div class="form-group has-float-label">
              <b-input readonly lableText="Floor" v-model="floor" />
              <label for="unitType">Floor</label>
            </div>
          </b-col>
          <b-col md="6">
            <div class="form-group has-float-label">
              <b-input readonly lableText="Block" v-model="block" />
              <label for="unitType">Block</label>
            </div>
          </b-col>
          <b-col md="6">
            <div class="form-group has-float-label">
              <b-input readonly lableText="Lease Start" v-model="leaseStart" />
              <label for="unitType">Lease Start</label>
            </div>
          </b-col>
          <b-col md="6">
            <div class="form-group has-float-label">
              <b-input readonly lableText="Lease End" v-model="leaseEnd" />
              <label for="unitType">Lease End</label>
            </div>
          </b-col>
          <b-col md="6">
            <DynamicInput
              :fields="externalInfoCustomer"
              :visibility="isVisible"
              ref="dynamicForm"
              @update:formData="handleExtendedAttributesUpdate"
            />
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-3">
          <b-button
            variant="success"
            class="mr-2"
            @click="$router.push({ path: '/customers' })"
            >CANCEL</b-button
          >
          <div v-if="isLoading" class="spinner-overlay">
            <div class="spinner"></div>
          </div>
          <b-button variant="success" @click="updateCustomer">UPDATE</b-button>
        </b-row>
      </b-card>
    </div>
  </ValidationObserver>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentHeader from "@/components/componentNewHeader";
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import {
  ValidationProvider,
  ValidationObserver,
  Validator,
} from "vee-validate";
import { mapState } from "vuex";
import DynamicInput from "@/components/Partner/additionalInfo.vue";
export default {
  components: {
    ComponentHeader,
    cInput,
    cTelInput,
    ebSelect,
    ValidationProvider,
    ValidationObserver,
    Validator,
    DynamicInput,
  },
  data() {
    return {
      externalInfoCustomer: [],
      extendedAttributes: {},
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      unit: "",
      unitType: "",
      floor: "",
      block: "",
      leaseStart: null,
      leaseEnd: null,
      units: [],
      isLoading: false,
      requestListData: null,
      unitOption: [
        { label: "1 Bed 1 Bath", value: { bed: 1, bath: 1 } },
        { label: "2 Bed 2 Bath", value: { bed: 2, bath: 2 } },
        { label: "3 Bed 2.5 Bath", value: { bed: 3, bath: 2.5 } },
        { label: "studio", value: { bed: 0, bath: 1 } },
      ],
    };
  },
  computed: {
    ...mapState({
      extendedList: (state) => state.tenant.extendedList,
      extendedData: (state) => state.onboardCustomer.extendedData,
    }),
    isVisible() {
      return this.externalInfoCustomer.length >= 0;
    },
  },
  methods: {
    handleExtendedAttributesUpdate(updatedData) {
      this.extendedAttributes = updatedData;
    },
    async getAttributeList() {
      await this.$store.dispatch("tenant/setExtendedAttributeList").then(() => {
        this.externalInfoCustomer = this.extendedList.externalInfoCustomer;
      });
      await this.getCustomerDetails();
      this.$refs.dynamicForm.setData(this.extendedData);
    },
    async requestList() {
      this.isLoading = true;
      const payload = {
        id: this.$route.params.id,
      };
      try {
        const response = await this.$store.dispatch(
          "onboardCustomer/requestList2Action",
          payload
        );
        this.requestListData = response.data;
      } catch (error) {
        console.error("Error fetching request list:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async onSelectUnitType(e) {
      const payload = {
        id: "66fa140f6a471d55dac5177b",
        bath: e.value.bath,
        bed: e.value.bed,
        page: 1,
      };
      await this.$store
        .dispatch("unit/fetchUnitDetails", payload)
        .then((res) => {
          this.units = res;
        });
    },
    async updateCustomer() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.isLoading = true;
      const payload = {
        id: this.$route.params.id,
        data: {
          name: { first: this.firstName, last: this.lastName },
          phone: this.phone,
          email: this.email,
          extendedAttributes: this.extendedAttributes,
        },
      };
      this.$store
        .dispatch("onboardCustomer/updateCustomer", payload)
        .then((res) => {
          this.isLoading = false;
          this.$swal({
            title: "Success",
            text: "Customer Onboarded successfully!",
            type: "success",
          });
          this.$router.go(-1);
        });
    },
    async getCustomerDetails() {
      await this.$store
        .dispatch("onboardCustomer/customerDetails", this.$route.params.id)
        .then((res) => {
          this.firstName = res?.name?.first;
          this.lastName = res?.name?.last;
          this.email = res?.authentication?.email;
          this.phone = res?.authentication?.phone;
          this.unit =
            this.requestListData.response[0].items[0].custom.unitNo || "N/A";
          this.unitType =
            this.requestListData.response[0].items[0].custom.UnitTitle || "N/A";
          this.floor =
            this.requestListData.response[0].items[0].custom.Floor || "N/A";
          this.block =
            this.requestListData.response[0].items[0].custom.Block || "N/A";
          this.leaseStart =
            this.requestListData.response[0].items[0].custom.leaseStart ||
            "N/A";
          this.leaseEnd =
            this.requestListData.response[0].items[0].custom.leaseEnd || "N/A";
        });
    },
  },
  async mounted() {
    await this.requestList();
    this.getAttributeList();
  },
  watch: {
    unit(newValue) {
      const selectedUnit = this.units.find((u) => u.unitNo === newValue.unitNo);
      if (selectedUnit) {
        this.floor = selectedUnit.Floor;
        this.block = selectedUnit.Block;
      }
    },
  },
};
</script>
<style scoped>
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
.spinner {
  border: 6px solid rgba(0, 0, 0, 0.1);
  border-left-color: #000;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
